import { AssetsElement } from '@lib/kontent/models/Elements'

export const getImageRatio = (image: AssetsElement): number => {
  return parseFloat((image.value[0].height / image.value[0].width).toFixed(2))
}
